import { segment } from '@actions/analytics';
import { LEADERBOARD_VIEWED } from '@cont/Compete/constants';
import styled from '@emotion/styled';
import useGoalEventProps from '@hooks/useGoalEventProps';
import useCompete from '@stores/compete';
import { Spacings } from '@styles/index';
import { useRouter } from 'next/router';
import FilterBox from './FilterBox';
import useFilter from './useFilter';

const FilterWrapper = styled.div`
  margin-top: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_6B};
  display: flex;
`;

const Filters = ({ className }) => {
  const { examFilter, stateFilter, setExamFilter, setStateFilter } =
    useCompete();
  const { goalUID } = useRouter();
  const goalSegmentData = useGoalEventProps({ goalUID });

  const { data } = useFilter();

  const {
    filters: { exams, states }
  } = data;

  const handleExamFilterSelect = (value) => {
    setExamFilter(value);
    segment.track(LEADERBOARD_VIEWED, {
      ...goalSegmentData,
      filter_type: 'Exam',
      filter_value: value?.name
    });
  };
  const handleStateFilterSelect = (value) => {
    setStateFilter(value);
    segment.track(LEADERBOARD_VIEWED, {
      ...goalSegmentData,
      filter_type: 'State',
      filter_value: value?.name
    });
  };

  return (
    <>
      <FilterWrapper className={className}>
        {exams?.length > 1 && (
          <FilterBox
            filterList={exams}
            handleFilterSelect={handleExamFilterSelect}
            selectedValue={examFilter}
            placeholder="All target exams"
          />
        )}
        {states?.length > 1 && (
          <FilterBox
            filterList={states}
            handleFilterSelect={handleStateFilterSelect}
            selectedValue={stateFilter}
            placeholder="All states"
          />
        )}
      </FilterWrapper>
    </>
  );
};

export default Filters;
